import React from 'react';
import { FileTextIcon, PrinterIcon, DownloadIcon } from 'lucide-react';
const details = [{
  icon: FileTextIcon,
  label: 'Every volume and bonus is a PDF'
}, {
  icon: PrinterIcon,
  label: 'Print any page or hand it out digitally'
}, {
  icon: DownloadIcon,
  label: 'Download instantly after checkout'
}];
export function FormatNotice() {
  return <section aria-labelledby="format-heading" className="bg-paper py-14 sm:py-20" data-id="element-116" data-mp="2aexkhjvmp8oz">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-117" data-mp="2y2xkzbiqsdgr">
        <p className="text-[10px] font-semibold uppercase tracking-label text-brass-dark sm:text-[11px]" data-id="element-118" data-mp="32494czb0w2gi">
          Format
        </p>
        <h2 id="format-heading" className="mt-4 font-display text-2xl font-semibold leading-snug text-ink sm:text-4xl" data-id="element-119" data-mp="2occe70sx02mr">
          All the content is PDF. There are no videos for now.
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-120" data-mp="3gzf97iydtv89">
          You get printable, editable documents you can use straight in class &mdash; no platform to
          log into, no video course to sit through.
        </p>

        <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-3 sm:gap-5 sm:text-center" data-id="element-121" data-mp="2dv0b8p9uj0bp">
          {details.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-3 border border-paper-300 bg-paper-100 p-4 sm:flex-col sm:gap-3" data-id="element-122" data-mp="2mundteebac6c">
              <Icon className="h-5 w-5 shrink-0 text-brass" aria-hidden="true" data-id="element-123" data-mp="31hqc3nagkouq" />
              <span className="text-xs leading-snug text-ink-soft" data-id="element-124" data-mp="2wjoul6sokxld">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}